import { useAppContext } from "../../../AppContext";
import { UserRole } from "../../enums";
import { getCurrentUserRole } from "../helpers/userHelper";
import { useApiQuery } from "./useApiQuery";
import { endpointsMetadata } from "../routes/endpointsMetadata";

const normalizePath = (path?: string) =>
  path?.toLowerCase()?.replace(/\/+$/, "");

/**
 * Whether the current user has at least one active subscription in the selected studio.
 * Drives the subscribed-only "+" create-workout button on the My Workouts page. Mirrors
 * useHasWorkouts: a lightweight boolean query gated behind the regular-user role + the
 * My Plans permission, so it never fires (and 403s) for other roles.
 */
export const useHasActiveSubscription = (): boolean => {
  const { currentUser, selectedStudio } = useAppContext();

  const isRegularUser = getCurrentUserRole(currentUser) === UserRole.User;

  const normalizedEndpoint = normalizePath(endpointsMetadata.myPlans.getAll);
  const hasPlansPermission =
    currentUser?.permissions?.some(
      (p) => !!normalizedEndpoint && normalizedEndpoint.includes(normalizePath(p)!),
    ) ?? false;

  const { data } = useApiQuery<boolean>(
    {
      queryKey: [
        endpointsMetadata.myPlans.hasActivePlan,
        selectedStudio?.id,
      ],
      endpoint: endpointsMetadata.myPlans.hasActivePlan,
      globalIsLoading: false,
      disableErrorToast: true,
      enabled: !!currentUser && isRegularUser && hasPlansPermission,
    },
    { staleTime: 60000 },
  );

  return data ?? false;
};
